import { render } from "./RecruitmentConfiguration.vue?vue&type=template&id=570d0fcf&scoped=true"
import script from "./RecruitmentConfiguration.vue?vue&type=script&lang=js"
export * from "./RecruitmentConfiguration.vue?vue&type=script&lang=js"

import "./RecruitmentConfiguration.vue?vue&type=style&index=0&id=570d0fcf&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570d0fcf"]])

export default __exports__